import { cn } from '@v2/shared/lib/utils';

type Props = {
  className?: string;
};

/**
 * The ResellerRatings seal.
 *
 * The click is intercepted so the seal opens in the sized popup their landing script
 * expects, rather than a normal tab. The href and target stay real so it still behaves
 * like a link to anything that is not running the handler — middle click, a crawler, a
 * screen reader listing links.
 *
 * Carries no chrome of its own: the footer wants a bare image, the bulk order page wants
 * a bordered card, so each caller passes its own className.
 */
export default function ResellerRatingsBadge({ className }: Props) {
  return (
    <a
      href="https://www.resellerratings.com"
      target="_blank"
      rel="noreferrer"
      onClick={(event) => {
        event.preventDefault();
        window.open(
          'https://seals.resellerratings.com/landing.php?seller=27560',
          'resellerratings',
          'height=760,width=780,scrollbars=1'
        );
      }}
      className={cn('inline-block overflow-hidden', className)}
    >
      <img
        src="https://seals.resellerratings.com/seal.php?seller=27560"
        alt="ResellerRatings"
        className="block border-0"
      />
    </a>
  );
}
